/**
 *  Counter animation
 */
const countNumbers = gsap.utils.toArray('.counter');

countNumbers.forEach(function (item, i) {
	const speed = 25; // lower is faster

	setTimeout(function () {

		ScrollTrigger.create({
			trigger: item,
			start:   'top bottom',
			end:     'bottom bottom',
			once:    true,
			markers: false,
			onEnter: () => {
				let number = item.textContent;
				number     = cleanNumber(number);

				item.innerText = 0;

				if (number !== '')
				{
					const animate = () => {
						const value = +cleanNumber(number);
						const data  = +cleanNumber(item.innerText);
						const time  = value / speed;

						if (data < value)
						{
							item.innerText = formatNumber(Math.ceil(data + time));
							setTimeout(animate, 40);
						}
						else
						{
							item.innerText = formatNumber(value);
						}

					}

					animate();
				}
			}
		});
	}, 100);

});

function formatNumber(number) {
	return new Intl.NumberFormat("it-IT", {
		useGrouping: 'always',
	}).format(number);
}

function cleanNumber(number) {
	return number.replace(/[^0-9]+/g, '');
}